import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AdminActionButton } from '../admin-action-button';
import { AdminEventListPanelProps } from './admin-event-list-panel-props';
import { AdminEventsTable } from '../admin-events-table';
import { AdminPanel } from '../admin-panel';
import { AdminPanelBackButton } from '../admin-panel-back-button';
import { AdminPanelBody } from '../admin-panel-body';
import { AdminPanelHeader } from '../admin-panel-header';
import { AdminPanelHeading } from '../admin-panel-heading';
import { AdminPanelHeadingAction } from '../admin-panel-heading-action';
import { AdminPanelHeadingText } from '../admin-panel-heading-text';
import { AdminPanelName } from '../../../state';
import { getWipPage } from '../../../selectors';
import { loadEvent } from '../../../actions';
import { replaceAdminPanel } from '../../../actions';
import { uuid } from '@robotsnacks/uuid';

export const AdminEventListPanel: React.FunctionComponent<
  AdminEventListPanelProps
> = (): React.ReactElement => {
  const dispatch = useDispatch();

  const wipPage = useSelector(getWipPage);

  const onNewEventClick = useCallback(() => {
    const eventKey = uuid();
    dispatch(
      loadEvent(
        eventKey,
        wipPage ? { pageId: wipPage.id, pageTitle: wipPage.title } : {},
      ),
    );
    dispatch(replaceAdminPanel(AdminPanelName.Event, { eventKey }));
  }, []);

  return (
    <AdminPanel>
      <AdminPanelHeader>
        <AdminPanelBackButton />
        <AdminPanelHeading>
          <AdminPanelHeadingText>Events</AdminPanelHeadingText>
          <AdminPanelHeadingAction>
            <AdminActionButton
              label="Create New Event"
              onClick={onNewEventClick}
            />
          </AdminPanelHeadingAction>
        </AdminPanelHeading>
      </AdminPanelHeader>
      <AdminPanelBody padding="narrow">
        <AdminEventsTable />
      </AdminPanelBody>
    </AdminPanel>
  );
};
